<aura-edit-wrapper
  [(isEditing)]="isEditing"
  (saved)="saved.emit($event)"
  [showDivider]="true"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing()) {
    <aura-internationalization-currency-form
      [dto]="currentCurrency()"
      [requiredFields]="['email']"
      [allReadonly]="!editWrapper.isEditing()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <aura-internationalization-currency-display [currentCurrency]="currentCurrency()" />
  }
</aura-edit-wrapper>
